import { Colors } from '@sigma-frontend-libs/commons'

import { buttonModes, components } from '@/utils'

import button from '@/components/button'
import info from '@/components/info'

function renderDialog(h) {
  return h(
    components.dialog,
    {
      props: {
        title: this.getTranslate('commons.titles.confirm.remove'),
        value: this.showDialog,
        closeOnClick: true,
        closeOnEsc: true,
        maxWidth: 400
      },
      on: {
        input: event => {
          this.showDialog = event
        }
      }
    },
    [
      h(
        'div',
        {
          class: 'px-2'
        },
        [
          h(
            info,
            {
              props: {
                value: this.getTranslate('commons.contents.confirm.confirm'),
                color: Colors.error
              }
            }
          )
        ]
      ),

      h(
        'div',
        {
          class: 'fjcfe grid-gap--8 pa-2',
          slot: 'footer'
        },
        [
          h(
            button,
            {
              props: {
                label: this.getTranslate('misc.buttons.close'),
                mode: buttonModes.flat,
                disabled: this.loading
              },
              on: {
                click: () => {
                  this.showDialog = false
                }
              }
            }
          ),
          h(
            button,
            {
              props: {
                label: this.getTranslate('misc.buttons.remove'),
                color: Colors.error,
                loading: this.loading,
                disabled: this.loading || this.disabled
              },
              on: {
                click: this.onRemove
              }
            }
          )
        ]
      )
    ]
  )
}

export default function(h) {
  let component = this.component
  if (this.component === 'button') {
    component = button
  }

  let buttonClass
  if (this.component === components.button) {
    buttonClass = 'ma-0'
  }

  return h(
    component,
    {
      class: buttonClass,
      props: this.$props,
      on: {
        click: event => {
          return this.onClick(event)
        }
      },
      scopedSlots: {
        dialog: () => {
          return renderDialog.call(this, h)
        }
      }
    }
  )
}
